import React from 'react';
import ConsultantReportsPage from './ConsultantReportsPage';

const EnterpriseReportsPage: React.FC = () => {
  return <ConsultantReportsPage scope="enterprise" />;
};

export default EnterpriseReportsPage;
